import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import Moment from 'react-moment'
import moment from 'moment'


export const TokensDataGrid = ({
  results,
  page_size,
  current,
  count,
  onTableChange,
  onFilter,
  canViewContactDetails
}) => {
  const organizationRowStyle = (organization, rowIndex) => {
    return organization.is_deleted
      ? { borderLeft: '10px solid red' }
      : { borderLeft: '10px solid green' }
  }

  const columns = [
    {
      dataField: 'status',
      text: 'Status',
      type: 'string',
      hidden: true,
      formatter: components.CellTextFormatter,
      searchFieldKey: 'status',
      searchFieldType: 'select',
      options: [
        {
          text: 'Waiting',
          value: 'waiting',
        },
        {
          text: 'Attended',
          value: 'attended',
        },
      ],
    },
    {
      dataField: 'organization_code',
      text: 'Organization',
      type: 'string',

      formatter: components.CellTextFormatter,
      searchFieldKey: 'organization',
      searchFieldType: 'text',
    },
    {
      dataField: 'token_number',
      text: 'Token Number',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldKey: 'token_number',
      searchFieldType: 'text',
    },
    {
      dataField: 'first_name',
      text: 'Name',
      type: 'string',
      formatter: (cell, row) =>
        components.CellTextFormatter(`${row.first_name} ${row.last_name}`),
      searchFieldType: 'text',
    },
    {
      dataField: 'email',
      text: 'Email',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
      hidden: !canViewContactDetails,
    },
    {
      dataField: 'contact_number',
      text: 'Contact Number',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
      hidden: !canViewContactDetails,
    },
    {
      dataField: 'category',
      text: 'Category',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'invite_sent_on',
      text: 'Invite Sent On',
      type: 'string',
      formatter: components.CellDateTimeFormatter,
    },

    {
      dataField: 'created_at',
      text: 'Created On',
      type: 'string',
      formatter: components.CellDateTimeFormatter,
      searchFieldType: 'date',
    },
    {
      dataField: 'customer_closed_on',
      text: 'Close On',
      type: 'string',
      formatter: components.CellDateTimeFormatter,
      searchFieldType: 'date',
    },
    {
      dataField: 'closed_by',
      text: 'Closed By',
      type: 'string',
      formatter: components.CellTextFormatter,
    },

    {
        dataField: 'has_customer_left',
        text: 'Has Customer Left',
       formatter: components.BooleanFormatterWithCSS("has_customer_left",
           'text-center'),
      searchFieldType: 'select',
        options: [
        {
          text: 'Waiting',
          value: false,
        },
        {
          text: 'Left',
          value: true,
        }]
    },
    {
      dataField: 'wait_time',
      text: 'Wait Time',
      formatter: (cell, row) => {
        const now = moment();
         const createdTime = moment(row.created_at);
         const durationInMinutes = now.diff(createdTime, 'minutes');
        if (row.invite_sent_on) {
          return (
            <span>
              <Moment diff={row.created_at} unit="minutes">
                {row.invite_sent_on}
              </Moment>{' '}
              Minutes
            </span>
          )
        }
        return (
           <span>
      {durationInMinutes > 8 * 60 ? (
        'Not Invited'
      ) : (
       <> <Moment diff={row.created_at} unit="minutes">
          {moment()}
        </Moment> </>
      )}{' '}

    </span>
        )
      },
    },
         {
      dataField: 'url',
      text: 'Change Log',
      formatter: components.ChangeLogFormatter,
    },
  ]
  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>Tokens</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-end" xs={6}>
            <components.Slider
              size="sm"
              sliderWidth={"20vw"}
              title={components.ICONS.SEARCH}
              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-1"> Tokens</span>
                </span>
              }
            >
              <components.GenericSearchForm
                onFilter={onFilter}
                columns={columns}
              />
            </components.Slider>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        <components.DataGrid
          data={results || []}
          rowStyle={organizationRowStyle}
          sizePerPage={page_size || 10}
          page={current || 1}
          columns={columns}
          count={count || 0}
          onTableChange={onTableChange}
        />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
